"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleProxyImage = handleProxyImage;
exports.useImageProxyHandler = useImageProxyHandler;
exports["default"] = exports.genProxySrc = void 0;

var _react = require("react");

var _constants = require("../utils/constants");

var _lazyImage = require("./lazyImage");

var genProxySrc = function genProxySrc(src, token) {
  return token ? "".concat(_constants.WM_API_HOST, "/v1/na/image_proxy/").concat(encodeURIComponent(src), "/").concat(token) : src;
};

exports.genProxySrc = genProxySrc;

function handleProxyImage(node, token) {
  if (node.hasAttribute(_lazyImage.EXTERNAL_IMG_ATTR)) {
    var originalSrc = node.getAttribute(_lazyImage.EXTERNAL_IMG_ATTR); // use for

    node.addEventListener('load', function () {
      node.setAttribute('data-loaded', true);
    });
    node.addEventListener('error', function () {
      if (node.getAttribute('src') !== originalSrc) {
        node.setAttribute('src', originalSrc);
      } else {
        node.setAttribute('data-loaded', true);
      }
    });
    node.setAttribute('referrerpolicy', 'no-referrer');
    node.setAttribute('src', genProxySrc(originalSrc, token));
  }

  if (node.hasAttribute(_lazyImage.BACKGROUND_IMG_ATTR)) {
    var backgroundImageUrl = node.getAttribute(_lazyImage.BACKGROUND_IMG_ATTR);
    var image = new Image();

    image.onload = function () {
      node.style.backgroundImage = "url(\"".concat(image.src, "\")");
    };

    image.onerror = function () {
      if (token) {
        node.style.backgroundImage = "url(\"".concat(backgroundImageUrl, "\")");
      }
    };

    image.src = genProxySrc(backgroundImageUrl, token);
  }
}

var _default = function _default(rootRef, authToken) {
  (0, _react.useEffect)(function () {
    if (!rootRef.current) return;

    if (rootRef.current.hasAttribute(_lazyImage.EXTERNAL_IMG_ATTR) || rootRef.current.hasAttribute(_lazyImage.BACKGROUND_IMG_ATTR)) {
      handleProxyImage(rootRef.current, authToken);
    } else {
      var imageNodes = rootRef.current.querySelectorAll("img[".concat(_lazyImage.EXTERNAL_IMG_ATTR, "], [").concat(_lazyImage.BACKGROUND_IMG_ATTR, "]"));
      imageNodes.forEach(function (node) {
        return handleProxyImage(node, authToken);
      });
    }
  }, [authToken]);
};

exports["default"] = _default;

function useImageProxyHandler(token) {
  return (0, _react.useCallback)(function (node) {
    return handleProxyImage(node, token);
  }, [token]);
}
//# sourceMappingURL=proxyImage.js.map